import React from 'react';

import { IBaseProps } from '@rbi-ctg/frontend';

const AddPaymentMethodIcon = (props: IBaseProps) => (
  <svg
    width="34"
    height="24"
    viewBox="0 0 34 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width="34" height="24" rx="4" fill="white" />
    <rect x="0.5" y="0.5" width="33" height="23" rx="3.5" stroke="black" strokeOpacity="0.1" />
    <path
      d="M22 12.8333H17.8333V17C17.8333 17.4583 17.4583 17.8333 17 17.8333C16.5417 17.8333 16.1667 17.4583 16.1667 17V12.8333H12C11.5417 12.8333 11.1667 12.4583 11.1667 12C11.1667 11.5417 11.5417 11.1667 12 11.1667H16.1667V6.99999C16.1667 6.54166 16.5417 6.16666 17 6.16666C17.4583 6.16666 17.8333 6.54166 17.8333 6.99999V11.1667H22C22.4583 11.1667 22.8333 11.5417 22.8333 12C22.8333 12.4583 22.4583 12.8333 22 12.8333Z"
      fill="#502314"
    />
  </svg>
);

export default AddPaymentMethodIcon;
